import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MatematickoStatistickeMetodeM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Matematičko-statističke metode" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Matematičko-statističke metode</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Matematičko-statističke metode
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Upoznavanje i ovladavanje sa osnovnim matematičkim i
                statističkim znanjima kao osnova za rešavanje poslovnih problema
                u oblasti kvantitativne analize, teoriji odlučivanja i donošenju
                poslovnih odluka neophodnih stručnjaku u oblasti marketinga,
                menadžmenta, finansija itd. Poznavanje modela privredne i
                finansijske matematike kao osnove za konkretno donošenje odluka
                u biznisu i kvantitativnoj analizi u svim oblastima biznisa.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Upućivanje ka logičkom razmišljanju sa ciljem razvijanja
                sposobnosti studenata da mogu navedene metode da primijene u
                ekonomskoj praksi pri individualnom i timskom rješavanju
                problema.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Funkcija jedne promjenljive (linearna,
                kvadratna, eksponencijalna, logaritamska); Izvod i diferencijal
                funkcije jedne realne promjenljive i primjena; Funkcije dvije
                nezavisno promjenljive; Modeli na bazi funkcionalnih zavisnosti
                (ekonomske funkcije); Integralni račun i primjena; Modeli
                privredne matematike; Prost kamatni račun; Složen kamatni račun;
                Amortizacija zajma; Pokazatelji empirijske raspodjele; Ocjena
                parametara; Regresija i korelacija; Vremenske serije; Relativni
                brojevi indeksi. Praktična nastava prati teorijsku nastavu,
                uključujući primjere iz ekonomije, prezentacije, diskusije i
                rješavanje praktičnih problema.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su predavanja i vježbe.
                Predavanja su zasnovana na prezentaciji svake metodske jedinice
                uz detaljno objašnjenje svih pitanja i problema, a obezbjeđuje i
                neposredno učešće studenta kroz mogućnost postavljanja
                odgovarajućih pitanja i vođenja diskusije. Na časovima
                predviđenim za vježbe obezbijeđeno je neposredno i aktivno
                učešće studenata kroz pojedinačnu i grupnu pripremu i usmeno
                referalnih radova – studija slučajeva pomoću kojih se detaljnije
                razrađuju i objašnjavaju i određena pitanja.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Funkcija jedne promjenljive (linearna, kvadratna,
                      eksponencijalna, logaritamska)
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Izvod i diferencijal funkcije jedne realne promjenljive i
                      primjena
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>Funkcije dvije nezavisno promjenljive</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Modeli na bazi funkcionalnih zavisnosti (ekonomske
                      funkcije)
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>Integralni račun i primjena</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>Modeli privredne matematike</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>Prost kamatni račun</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>Složen kamatni račun</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>Amortizacija zajma</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>Pokazatelji empirijske raspodjele</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>Ocjena parametara; Regresija i korelacija</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>Vremenske serije</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>Relativni brojevi indeksi</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 430 h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 300 h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MatematickoStatistickeMetodeM;
